import React, { useState } from 'react';
import __t from '../../lib/traduzioni';
import { Controller, useWatch } from 'react-hook-form';
import useBSSController from '../../hooks/useBSSController';
import useBSSLogger from '../../hooks/useBSSLogger';
import { Paper, Typography, Box, LinearProgress, Divider } from '@mui/material';
import { makeStyles } from "@mui/styles";

import DefaultLoadingComponent from './DefaultLoadingComponent';
import useInitialLoader from '../../hooks/useInitialLoader';
import { addSeconds, differenceInSeconds, endOfDay, getDate, getISODay, getMonth, format, addDays, isMatch, getDay, compareDesc, parse } from 'date-fns'
import { useInterval } from 'react-use';
import { convertToDuration, humanDuration } from '../../lib/dateshelper';
import { CheckBoxRounded, CheckBoxOutlineBlank, Today } from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import DatePicker from "@mui/lab/StaticDatePicker"
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import { alpha } from '@mui/material';
import { LocalizationProvider } from '@mui/lab';
import BSSDialog, { BSSDialogWithActions } from './BSSDialog';

const {logger} = useBSSLogger();



const useStyles = makeStyles((theme) => {

    const hoveredBorder = {
        //border: `thin solid ${theme.palette.primary.main}`,
        boxShadow:  `0 0 0 .2rem ${alpha(theme.palette.secondary.main, 0.5)} !important`
    };
    
    return {
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            '& > *': {
                margin: theme.spacing(1),
                width: theme.spacing(16),
                height: theme.spacing(16),
            },
        },
        paperDate: {
            position: "relative",
            cursor: "pointer",
            "&:hover": {            
                ...hoveredBorder
            }                        
        },
        selected: {
            position: "absolute",
            top: "0px",
            right: "0px",
        },
        paperDateSelected: {
            border: `thin solid ${theme.palette.primary.main}`,
            boxShadow:  `0 0 0 .2rem ${alpha(theme.palette.primary.main, 0.5)} !important`
        },
        paperDateDisabled: {
            position: "relative",
            backgroundColor: theme.palette.grey[100],
            "& > *": {
                color: `${theme.palette.grey[600]} !important`
            },
            "&:hover": {            
                cursor: "not-allowed"
            } 
        },
        centered: {
            textAlign: 'center'
        }
    }
});

const mappaGiorni3 = {
    1: __t("Mon"),
    2: __t("Tue"),
    3: __t("Wed"),
    4: __t("Thu"),
    5: __t("Fri"),       
    6: __t("Sat"),       
    7: __t("Sun")
};

const mappaGiorni = {
    1: __t("Monday"),
    2: __t("Tuesday"),
    3: __t("Wednesday"),
    4: __t("Thursday"),
    5: __t("Friday"),
    6: __t("Saturday"),
    7: __t("Sunday")
}

const mappaMesi = {
    1: __t("January"),
    2: __t("February"),
    3: __t("March"),
    4: __t("April"),
    5: __t("May"),
    6: __t("June"),
    7: __t("July"),
    8: __t("August"),
    9: __t("September"),
    10: __t("October"),
    11: __t("November"),
    12: __t("December")
}

const mappaMesi3 = {
    1: __t("Jan"),
    2: __t("Feb"),
    3: __t("Mar"),
    4: __t("Apr"),
    5: __t("May"),
    6: __t("Jun"),
    7: __t("Jul"),
    8: __t("Aug"),
    9: __t("Sep"),
    10: __t("Oct"),
    11: __t("Nov"),
    12: __t("Dec")
}


const defaultFormat = "yyyy-MM-dd"
const valueFormatter = (option, formato = defaultFormat) => {
    
    let res = "";
    if(![null, ""].includes(option)){
        res = format(option, formato);
    }
    logger.finest("formatto la data", option, "nel formato", formato, res);
    return res
}


const BSSDateSelector = ({
    name, 
    label = name,
    methods,
    dependsOn = null,
    ControllerProps = {},
    LoadingComponent = DefaultLoadingComponent,
    dataProvider = [], 
    CardProps = {},
    formato = defaultFormat,
    testoScadenza = __t("ritiroingiornataentro")
}) => {

    const {loading, error, data: options} = useInitialLoader({name, dataProvider})
    
    return (
            <>
                {loading && <LoadingComponent />}
                {error && `Si è verificato un errore ${error}`}
                {(!error && !loading && options?.length) && (
                    <_BSSDateSelector {...{
                        name, 
                        label,
                        methods,
                        dependsOn,
                        options,
                        ControllerProps,
                        CardProps,
                        formato
                    }} />
                )}
            </>
        
    )
}

const _BSSDateSelector = ({
    name, 
    label = name,
    methods,
    dependsOn = null,
    options,
    ControllerProps = {},
    PaperProps = {},
    formato = defaultFormat,
    testoScadenza = __t("ritiroingiornataentro")
}) => {

    options = [...(options ?? []), null];

    const [apriCalendario, setApriCalendario] = useState({mostra: false, field: null});
    
    const selezioneDefault = options.reduce((obj, o) => ({
        ...obj,
        [valueFormatter(o, formato)]: false
    }), {})


    const [timers, setTimers] = useState({});

    let pulisci = {};

    options.forEach((option, indiceOption) => {

        const chiave = indiceOption; //format(option, "T");

        pulisci[chiave] = false;

        useInterval(() => {


            const inizio = timers?.[chiave]?.inizio ?? new Date();
            const istante = new Date();
            const scadenza = addSeconds(option, 0);                
            const secondidisponibili = differenceInSeconds(scadenza, istante);
            const finegiornata = endOfDay(istante);
            const scadenzaingiornata = differenceInSeconds(scadenza, finegiornata) <= 0;
            const stoppa = secondidisponibili <= 0 || !scadenzaingiornata;            
            const progresso = differenceInSeconds(istante, inizio);
            const tempototale = differenceInSeconds(scadenza, inizio);
            const percentuale = (progresso / tempototale) * 100;
            const label = convertToDuration(secondidisponibili);
            const humanlabel = humanDuration(secondidisponibili);
    
            setTimers({
                ...timers,
                [chiave]: {
                    inizio,
                    secondidisponibili,
                    percentuale,
                    stoppa,
                    label,
                    humanlabel,
                    scadenzaingiornata
                }
            })
            logger.finest(`per l'opzione ${indiceOption}) ${secondidisponibili} (${percentuale}%) secondi ${stoppa && 'stoppo il conto alla rovescia'}`)
    
        }, (timers?.[chiave]?.stoppa ?? false) ? null : 1000)
    })

    const {classes, control, dipendenze, disabilitaByDep, defaultValue} = useBSSController({name, defaultValue: null, dependsOn, methods})

    //const dataRitiroIniziale = methods.getValues("dataritiro") ?? addDays(new Date(), -1);
    const selezioneIniziale = {
        ...selezioneDefault,
        //[dataRitiroIniziale]: dataRitiroIniziale
    }
    const [selezione, setSelezione] = useState(selezioneIniziale)


    const datesClasses = useStyles();

    const selezionaData = (option, field) => {
        logger.debug("click sull'opzione selettore date", option)

        const value = isMatch(option, "yyyy-MM-dd") ? option : valueFormatter(option, formato)

        
        field?.onChange(value)
        
        setSelezione({
            ...selezioneDefault,
            [value]: true
        })
    }

    /**
     * se il valore viene modificato programmaticamente intercetto la modifica e aggiorno lo stato della selezione
     */
    const dataForm = useWatch({control, name})

    if(dataForm !== null && dataForm !== undefined){
        const isDataSelezionata = selezione?.[dataForm] ?? false;

        if(!isDataSelezionata){
            selezionaData(dataForm)
        }

    }

    const lastOption = (options?.[options.length - 2] ?? new Date());

    const [altraData, setAltraData] = useState(addDays(lastOption, 1));

    const dataSelezionata = methods.getValues(name);
    const dataSelezionataLabel = ["", null, undefined].includes(dataSelezionata) ? false : format(parse(dataSelezionata, "yyyy-MM-dd", new Date()), "dd/MM/yyyy");
    
    const noSelezione = options
        .map(o => valueFormatter(o))
        .reduce((esito, val) => {
            esito = esito && selezione[val] !== true
            return esito
        }, true)



    return (
        <div>
            {/* <pre>{JSON.stringify(options, null, 2)}</pre> */}

            <BSSDialogWithActions 
                open={apriCalendario.mostra} 
                closeHandler={e => setApriCalendario({mostra: false, field: null})}
                title={""}
            >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker 
                        displayStaticWrapperAs="desktop"
                        autoOk
                        value={altraData}
                        onChange={v => {
                            logger.debug("selezionata data da datePicker", v)
                            setAltraData(valueFormatter(v))
                            selezionaData(v, apriCalendario.field)
                            setApriCalendario({mostra: false, field: null})
                        }}
                        clearable
                        orientation="landscape"
                        openTo="day"
                        disablePast 
                        shouldDisableDate={d => [0, 6].includes(getDay(d)) || (compareDesc(lastOption, d) < 0)} 
                        renderInput={(params) =>""}
                    />
                </LocalizationProvider>
            </BSSDialogWithActions>

            {dataSelezionataLabel && (
                <Alert severity="info">
                    {__t("dataselezionata")}: <b>{dataSelezionataLabel}</b>
                </Alert>
            )}
            
            {/* <pre>{JSON.stringify(selezione, null, 2)}</pre>
            <pre>{JSON.stringify(options.map(o => valueFormatter(o)), null, 2)}</pre>
            <pre>no selezione?{noSelezione}</pre> */}

            <Controller
                name={name} 
                control={control}     
                defaultValue={defaultValue}                                           
                render={({field, fieldState, formState}) => (
                    <>      
                        {(fieldState?.error ?? false) && (
                            <Box width={1} mt={1}  >
                                <Alert  severity="error">
                                    {fieldState.error.message}
                                </Alert>                                                            
                            </Box>
                        )}

                        
                        
                        <div className={datesClasses.root}>
                            {options.map((option, optionIndex) => {

                                const {
                                    inizio,
                                    secondidisponibili,
                                    percentuale,
                                    stoppa,
                                    label,
                                    humanlabel,
                                    scadenzaingiornata
                                } = timers?.[optionIndex] ?? {};

                                const festivita = [6,7].includes(getISODay(option))
                                const disabilita = festivita || false;

                                const inGiornata = scadenzaingiornata
                                const labelGiorno = inGiornata ? __t("oggi") : getDate(option).toString().padStart(2, "0")


                                return (scadenzaingiornata && stoppa) ? ("") : (
                                        <Paper 
                                            title={!(timers?.[optionIndex]?.stoppa ?? true) && `${__t("ritiroingiornataentro")} ${humanlabel}`}
                                            className={`${!disabilita ? datesClasses.paperDate : datesClasses.paperDateDisabled} ${(selezione[valueFormatter(option, formato)] || (option === null && dataSelezionataLabel && noSelezione)) ? datesClasses.paperDateSelected : ''}`} 
                                            key={optionIndex} 
                                            variant="outlined" 
                                            onClick={e => {
                                                if(!disabilita){
                                                    if(option !== null){
                                                        selezionaData(option, field)
                                                    } else {
                                                        setApriCalendario({mostra: true, field})
                                                    }
                                                }
                                                
                                                
                                            }}
                                            {...PaperProps}
                                        >       
                                            
                                            {!(timers?.[optionIndex]?.stoppa ?? true) && (     
                                                // <motion.div
                                                //     animate={{scale: [1, 1.05, 1]}}
                                                //     transition={{duration: 2, ease: "easeInOut", times: [0, 0.5, 1], loop: Infinity, repeatDelay: 0}}
                                                // >
                                                    <Typography color="textSecondary">                                                        
                                                        {timers?.[optionIndex]?.humanlabel}
                                                    </Typography>
                                                // </motion.div>
                                                
                                            )}

                                            {option !== null && (
                                                selezione[valueFormatter(option, formato)] ? (
                                                    <CheckBoxRounded color="primary" className={datesClasses.selected} /> 

                                                ): (
                                                    <CheckBoxOutlineBlank color="primary" className={datesClasses.selected} />
                                                )      
                                            )}                                            

                                            {/* {option === null && dataSelezionataLabel && noSelezione && (
                                                
                                                <CheckBoxRounded color="primary" className={datesClasses.selected} /> 
                                                
                                            )} */}


                                            <center>
                                                <>
                                                    {option !== null ? (
                                                        <>
                                                            <Box mt={(timers?.[optionIndex]?.stoppa ?? true) ? 3 : 0}>
                                                                <Typography className={datesClasses.centered} variant="body1">
                                                                    {mappaGiorni3[getISODay(option)]}
                                                                </Typography>
                                                            </Box>
                                                            
                                                            {!(timers?.[optionIndex]?.stoppa ?? true) ? (
                                                                                                        
                                                                    <>
                                                                        <Box width={1} mt={-0.2}>
                                                                            <LinearProgress variant="determinate" value={percentuale ?? 0} />
                                                                        </Box>
                                                                    </>
                                                            ) : (
                                                                <Divider />
                                                            )}

                                                            <Typography className={datesClasses.centered} 
                                                                variant={ inGiornata ? "h4" : "h3"}
                                                                sx={inGiornata && {pt: 0.9, pb: 0.8}}
                                                            >                                                                
                                                                {labelGiorno}
                                                            </Typography>

                                                            {!(timers?.[optionIndex]?.stoppa ?? true) ? (
                                                                                                        
                                                                    <>
                                                                        <Box width={1} mt={-0.2}>
                                                                            <LinearProgress variant="determinate" value={percentuale ?? 0} />
                                                                        </Box>
                                                                    </>
                                                            ) : (
                                                                <Divider />
                                                            )}
                                                                                                                                                            
                                                            <Typography className={datesClasses.centered} variant="body1">
                                                                {mappaMesi3[getMonth(option)+1]}
                                                            </Typography>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Box mt={3}>
                                                                <Typography className={datesClasses.centered}>
                                                                    {__t("altradata")}
                                                                </Typography>
                                                            </Box>
                                                            <Divider />
                                                            <Box mt={1}>
                                                                <Typography variant="h3">
                                                                    <Today fontSize="inherit" />
                                                                </Typography>
                                                            </Box>
                                                            
                                                            
                                                        </>
                                                    )}
                                                    
                                                </>                                                                                        
                                                
                                                
                                            
                                            </center>

                                        </Paper>
                                )
                            })}      
                            {/* <div style={{clear: "both"}}></div>                      
                            <pre style={{width: "100%"}}>{JSON.stringify(fieldState, null, 2)}</pre>
                            <pre style={{width: "100%"}}>{JSON.stringify(field.value, null, 2)}</pre>
                            <pre style={{width: "100%"}}>{JSON.stringify(selezione, null, 2)}</pre>
                            <pre style={{width: "100%"}}>{JSON.stringify(formState.errors[name], null, 2)}</pre> */}
                        </div>
                    </>

                )}
                {...ControllerProps}        
            />                        
        </div>
    )
}

export default BSSDateSelector; 
export {mappaGiorni, mappaGiorni3, mappaMesi, mappaMesi3}